import { DraftOnly } from "@components/project/DraftModeRequired.component";
import PageStructure, { PageContent, PageContentHeader, PageContentInner, PageSidebar, Pane, PaneContent } from "@pages/PageStructure.component";
import { getGroupValueForNodeType } from "@services/modeling.service";
import { savePipelineNode, useMissionControlDataFlowData } from "@stores/data.store";
import { useCallback, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataModelSubnav from "@components/datamodel/DataModelSubnav.component";
import { ReportBuilderMeasureORM, useDimensions, useMeasures } from "@models/reportBuilder";
import PipelineNodeList, { MetricGrid, NodeGrid } from "@components/pipelineNodes/PipelineNodeList.component";
import { DashboardIcon } from "@components/pipelineNodes/PipelineNodeIcon.component";
import { getPromptAnswer } from "@services/alert/alert.service";
import toast from "@services/toast.service";
import { getErrorMessage } from "@services/errors.service";
import ObjectListHeader from "@components/common/ObjectListHeader.component";
import { summarizeNumber } from "@services/formatting.service";
import { timeAgo, parseDateString } from "@services/time.service";
import MetricsList from "@components/metrics/MetricsList.component";

const DataModelTablePage = () => {
    const [search, setSearch] = useState('');
    const { data: dimensions } = useDimensions();
    const data = useMissionControlDataFlowData();

    const entities = useMemo(() => {
        if (!data.data) return [];
        return data.data.nodes.filter(node => 
            getGroupValueForNodeType(node.data.nodeType) === 'DATA_MODELING'
        );
    }, [data.data]);

    const navigate = useNavigate();

    const createNewEntity = useCallback(async () => {
        const newName = await getPromptAnswer('What do you want to name this entity?', 'New Entity');
        if (!newName) {
            return;
        }

        try {
            const newEntity = await savePipelineNode({
                id: null,
                node_type: 'DIMENSION',
                name: newName,
                label: newName,
                description: '',
                upstream_node_ids: [],
                fields: [],
                table_name: '',
            });
            navigate('/node/' + newEntity.id + '/config');
        } catch (err) {
            toast('danger', 'Error', getErrorMessage(err));
        }
    }, []);

   
    const createNewMetric = useCallback(async () => {
        const newName = await getPromptAnswer('What do you want to name this metric?', 'New Metric');
        if (!newName) {
            return;
        }

        try {
            const newMetric = await ReportBuilderMeasureORM.save({
                id: null,
                name: newName,
                column_name: newName,
                description: '',
            });
            navigate('/metrics/' + newMetric.id);
        } catch (err) {
            toast('danger', 'Error', getErrorMessage(err));
        }
    }, []);

    return (
        <PageStructure>
            <PageContent>
                <PageContentHeader>
                    <div className="d-flex center-vertically">
                        
                        <div style={{width:'40%'}}>
                            <h1 className="mb-0">Semantic Layer</h1>
                            <div className="text-muted font-13">View and manage your business entities and metrics</div>
                        </div>
                        <div className="flex-1 ps-5 pe-5">
                            <input 
                                type="text" 
                                className="form-control input-rounded input-search" 
                                placeholder="Search entities and metrics..." 
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                            />
                        </div>
                        <div>
                            <div className="btn-group">
                                <Link to="/model/list" className="btn btn-light active">
                                    <i className="mdi mdi-view-list"></i> Table
                                </Link>
                                <Link to="/model/visual" className="btn btn-light">
                                    <i className="mdi mdi-transit-connection-variant"></i> Visual
                                </Link>
                            </div>
                        </div>
                    </div>
                </PageContentHeader>
                <PageContentInner hasHeader>
                    <div className="p-4">
                        <div className="mb-5">
                            <PipelineNodeList
                                headerIcon="mdi mdi-table-star"
                                headerIconColor="purple"
                                title="Entities"
                                actionButtonText="New Entity"
                                actionButtonIcon="mdi mdi-plus-thick"
                                actionButtonOnClick={createNewEntity}
                                searchQuery={search}
                                nodeFilter={(node) => getGroupValueForNodeType(node.node_type) === 'DATA_MODELING'}
                            />
                        </div>
                        <div>
                            <ObjectListHeader
                                headerIcon={<DashboardIcon compact bgColor='green' icon="mdi mdi-pound-box"/>}
                                title="Metrics"
                                actionButtonText="New Metric"
                                actionButtonIcon="mdi mdi-plus-thick"
                                actionButtonOnClick={createNewMetric}
                            />  
                            <MetricsList searchQuery={search}/>

                        </div>
                        
    
                    </div>
                    

                        
                </PageContentInner>
            </PageContent>
        </PageStructure>
    );
};

export default DataModelTablePage;